import { defineNuxtPlugin } from '#app';
import { vProtect } from '~/directives/protect';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('protect', vProtect);
});
